import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import icon from "../../images/icon/magic.png";
import about1 from "../../images/icon/Buga/user.png";
import about2 from "../../images/icon/Buga/beneficiary.png";
import about4 from "../../images/icon/Buga/pound.png";
import about3 from "../../images/icon/Buga/online-transfer.png";
import heroimg from "../../images/icon/Buga/buga-money-apps-iamges.png";

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section id="about" className="about m-lr">
      <div className="about-wrapper sec-bg pos-rel pb-130 pt-130">
        <div className="container">
          <div className="sec-title--two text-center">
            <Fade
              direction="down"
              triggerOnce={"false"}
              duration={1500}
              delay={9}
            >
              <h2
                className="title wow fadeInDown"
                data-wow-delay="150ms"
                data-wow-duration="600ms"
              >
                Register, Transfer, Refer – The Buga Money
              </h2>
            </Fade>
          </div>
          <div className="row align-items-center ">
            <div className="col-lg-6 mt-50">
              <div className="about-left">
                <div className="about-item_box ul_li">
                  <div className="xb-item--icon">
                    <img
                      src={about1}
                      style={{ height: "70px", width: "70px" }}
                      alt=""
                    />
                  </div>
                  <div className="xb-item--holder">
                    <p className="xb-item--content">
                      <span>Register / Login to our Platform:</span> Sign-up to
                     Buga Money using our Mobile App or
                      Website. Enter your details and we will activate your
                      account instantly.
                    </p>
                  </div>
                </div>
                <div className="about-item_box ul_li">
                  <div className="xb-item--icon">
                    <img
                      src={about2}
                      style={{ height: "70px", width: "70px" }}
                      alt=""
                    />
                  </div>
                  <div className="xb-item--holder">
                    <p className="xb-item--content">
                      <span>Add Beneficiary:</span> Sign In and add
                      beneficiaries into your account. There is no limit on the
                      number of beneficiaries you can add into your account with
                      us.
                    </p>
                  </div>
                </div>
                <div className="about-item_box ul_li">
                  <div className="xb-item--icon">
                    <img
                      src={about3}
                      style={{ height: "70px", width: "70px" }}
                      alt=""
                    />
                  </div>
                  <div className="xb-item--holder">
                    <p className="xb-item--content">
                      <span>Transfer Money:</span> Select the beneficiary you
                      want to send money to and pay for your transfer. Simple,
                      quick and easy.
                    </p>
                  </div>
                </div>
                <div className="about-item_box ul_li">
                  <div className="xb-item--icon">
                    <img
                      src={about4}
                      style={{ height: "70px", width: "70px" }}
                      alt=""
                    />
                  </div>
                  <div className="xb-item--holder">
                    <p className="xb-item--content">
                      <span>Earn £5 per Referral:</span> Refer a Friend to
                      Buga Money and we add £5 to your Wallet
                      balance when they signup and make a qualifying transfer.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mt-50">
              <div className="about-right ">
                <img
                  className="wow fadeInLeft"
                  data-duration=".7s"
                  src={heroimg}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
